import * as React from 'react';

import { Messages } from '~src/codegen/Localize';

import { IAdminPermission } from '../../models/IAdminProfile';
import { AdminProfileStyles } from '../../styles/AdminProfileStyles';
import { AdminProfileCapabilitiesList } from '../AdminProfileCapabilitiesList';

function permissionsToCategoryMap(
  permissions: ReadonlyArray<IAdminPermission>
): Record<string, string[]> {
  const map: Record<string, string[]> = {};
  permissions.forEach(p => {
    if (!map[p.category]) {
      map[p.category] = [];
    }
    if (!map[p.category].includes(p.name)) {
      map[p.category].push(p.name);
    }
  });
  return map;
}

function isCapabilityEnabledFromPermissions(
  permissions: ReadonlyArray<IAdminPermission>
): (category: string, capability: string) => boolean {
  return (category: string, capability: string) => {
    const p = permissions.find(
      x => x.category === category && x.name === capability
    );
    return p?.enabled ?? false;
  };
}

export interface AdminProfilePermissionsTabProps {
  permissions: ReadonlyArray<IAdminPermission>;
}

export const AdminProfilePermissionsTab: React.FC<AdminProfilePermissionsTabProps> = ({
  permissions,
}) => {
  const permissionsMap = React.useMemo(
    () => permissionsToCategoryMap(permissions),
    [permissions]
  );

  const isEnabled = React.useMemo(
    () => isCapabilityEnabledFromPermissions(permissions),
    [permissions]
  );

  if (permissions.length === 0) {
    return (
      <div className={AdminProfileStyles.TabContent}>
        <div className={AdminProfileStyles.EmptyState}>
          <div className={AdminProfileStyles.EmptyStateTitle}>
            {Messages.adminProfilePermissionsEmptyTitle()}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={AdminProfileStyles.PermissionsTabContent}>
      <AdminProfileCapabilitiesList
        permissions={permissionsMap}
        isCapabilityEnabled={isEnabled}
        readOnly={true}
        showDescription={false}
        testIdPrefix="admin-profile-permissions-capability"
        containerClassName={AdminProfileStyles.PermissionsContainerFull}
      />
    </div>
  );
};

AdminProfilePermissionsTab.displayName = 'AdminProfilePermissionsTab';
